// Round 3, Lane 3 copy (10/17): time of day and weekday filter (R-103), booking note (R-105), one-tap calendar that
// remembers the calendar you use (R-23, R-24). Opus draft, Astra pass pending (AGENTS.md: Astra drafts customer copy and
// Claude gates it; Astra was not reachable from this lane, so Opus drafted and this file says so). Plain and short, no
// dashes, no exclamation marks, "activities" not "listings". Its own file so the lane merges cleanly.
export const R3F = {
  // R-103 time of day and weekdays (the part names match the plan's chips: copyLaneA la.part_*)
  'r3f.time.legend': "Time of day",
  'r3f.time.tip': "Events show if they start then. Places show if they are open then. Places with no listed hours always show.",
  'r3f.part.morning': "Morning",
  'r3f.part.afternoon': "Afternoon",
  'r3f.part.evening': "Evening",
  'r3f.part.late': "Late night",
  'r3f.days.legend': "Days",
  'r3f.days.tip': "Pick the days you are free.",
  'r3f.day.0': "Sun",
  'r3f.day.1': "Mon",
  'r3f.day.2': "Tue",
  'r3f.day.3': "Wed",
  'r3f.day.4': "Thu",
  'r3f.day.5': "Fri",
  'r3f.day.6': "Sat",
  'r3f.day_long.0': "Sunday",
  'r3f.day_long.1': "Monday",
  'r3f.day_long.2': "Tuesday",
  'r3f.day_long.3': "Wednesday",
  'r3f.day_long.4': "Thursday",
  'r3f.day_long.5': "Friday",
  'r3f.day_long.6': "Saturday",
  // R-105 booking note (appointment-only and reservation-only places)
  'r3f.book.appointment': "By appointment only. Book a time before you go.",
  'r3f.book.reservation': "Reservations needed. Book before you go.",
  'r3f.book.link': "Book a time",
  // R-23 / R-24 one tap to your calendar, asked once
  'r3f.cal.ask': "Which calendar do you use? We'll remember it.",
  'r3f.cal.other_google': "Use Google Calendar instead",
  'r3f.cal.other_apple': "Use Apple Calendar instead",
  'r3f.cal.switch_note': "You can change this in Settings.",
} as const

export type R3fKey = keyof typeof R3F
/** A Lane 3 line, with {placeholders} filled. */
export const r3f = (k: R3fKey, vars: Record<string, string | number> = {}): string =>
  R3F[k].replace(/\{(\w+)\}/g, (m, name: string) => (name in vars ? String(vars[name]) : m))
